import { UIOverlayViewStatus } from 'common-ts/dist/models/UIOverlayViewStatus';

import {
  Box, Button, createStyles, Dialog, Grid, IconButton, makeStyles, Theme, Typography, useTheme, CircularProgress
} from '@material-ui/core';
import { ArrowBack, Close, CloseOutlined } from '@material-ui/icons';
import AddTaskIcon from '@mui/icons-material/AddTask';
import ChecklistRtlIcon from '@mui/icons-material/ChecklistRtl';
import Icon from '@mui/material/Icon';

import { FareastButton } from './OverlayComponentButton';
import { useAppDispatch, useAppSelector } from '../reduxhooks';
import { Order } from 'common-ts/dist/models/Orders';
import { BodyMeasurements, BodyMeasurementsForSize } from 'common-ts/dist/models/UserMeasurements';
import { closeOverlayAndReset as closeOverlayAndResetEditView, openOverlay as openOverlayEditView, setValues as setValuesEditView } from '../redux/UIOverlayMeasurementEditViewRedux';
import React, { useEffect } from 'react';
import OverlayComponentButton from './OverlayComponentButton';
import { RegularSizeValue } from 'common-ts/dist/models/Cart';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backButton: {
      position: 'absolute',
      top: theme.spacing(3),
      right: theme.spacing(2),
      borderRadius: '50%',
      padding: theme.spacing(1),
    },
    backButtonIcon: {
      padding: '0',
      color: 'black',
    },
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '1em 1.5em',
      overflowY: 'hidden',
    },
    pageTitleTop: {
      marginTop: '1em',
      fontSize: '0.6em',
      color: '#454545',
      width: '80%',
      fontWeight: 400,
    },
    pageTitle: {
      marginTop: '1em',
      fontSize: '1.2em',
      width: '100%',
      fontWeight: 550,
    },
    pageItem: {
      display: 'grid',
      gridTemplateColumns: '1fr 8fr',
      marginTop: '1em',
    },
    pageItemIcon: {
      marginRight: '0.2em',
    },
    pageItemTitle: {
      paddingTop: '0.2em',
      fontSize: '0.8em',
      fontWeight: 500,
    },
    pageItemDescription: {
      gridColumn: '2',
      paddingTop: '0.2em',
      paddingRight: '0.5em',
      fontSize: '0.7em',
    },
  }),
);

interface ClothBodyMeasSuggestion {
  productId: string
  productName: string
  measurementName: string
  productDisplayImage: string
  purchaseDateString: string
  clothMeasValue: BodyMeasurements
  purchaseCount: number
  clothingType: string
  fitType: string
  userMeasurementsForItem: any
}

function getClothBodyMeasSuggestions(ordersList: Order[]) {

  const paidClothBodyMeasSuggestion: ClothBodyMeasSuggestion[] = [];

  for (var i = 0; i < ordersList.length; i += 1) {
    const currentOrder = ordersList[i];
    if (currentOrder.paymentStatus === 'capture' || 
    currentOrder.paymentStatus === 'capture_stockonly' || 
    currentOrder.paymentStatus === 'settlement' || 
    currentOrder.paymentStatus === 'capture_marketplace') {
      for (var j = 0; j < currentOrder.cartProductList.length; j += 1) {
        const currentPaidItem = currentOrder.cartProductList[j];
        paidClothBodyMeasSuggestion.push({
          productId: currentPaidItem.productDetail.productId,
          productName: currentPaidItem.productDetail.name,
          productDisplayImage: currentPaidItem.productDetail.displayImage,
          measurementName: (currentPaidItem.userMeasurementsForItem as any)?.measurementName ?? (currentPaidItem.userMeasurementsForItem as any)?.regularSize,
          purchaseDateString: currentOrder.creationDateTime,
          clothMeasValue: currentOrder.paymentStatus === 'capture_marketplace' ? 
          ((currentPaidItem.userMeasurementsForItem as any).regularSize ? BodyMeasurementsForSize?.[(currentPaidItem.userMeasurementsForItem as any).regularSize as RegularSizeValue] : {})
          : (currentPaidItem.userMeasurementsForItem as any)?.adjustedMeasurements,
          purchaseCount: ordersList.length - i,
          clothingType: (currentPaidItem as any)?.clothingType,
          fitType: (currentPaidItem as any)?.fitType,
          userMeasurementsForItem: currentOrder.paymentStatus === 'capture_marketplace' ? 
          {
            ...(currentPaidItem.userMeasurementsForItem as any),
            adjustedMeasurements: (currentPaidItem.userMeasurementsForItem as any).regularSize ? BodyMeasurementsForSize?.[(currentPaidItem.userMeasurementsForItem as any).regularSize as RegularSizeValue] : {},
          } as any
          : (currentPaidItem.userMeasurementsForItem as any),
        })
      }
    }
  }

  return paidClothBodyMeasSuggestion;
}

interface PreviousSizeSuggestionElementProps {
  srcImageUrl: string
  productName: string
  measurementName: string
  clothingType: string
  fitType: string
  userMeasurementsForItem: any
  purchaseDateTime: string
  isSelected: boolean
  purchaseCount: number
  handleClick: () => void
  handleConfirmation: () => void
}

const counterText = ['Pertama', 'Pertama', 'Kedua', 'Ketiga', 'Keempat', 'Kelima', 'Keenam', 'Ketujuh', 'Kedelapan'];

export function PreviousSizeSuggestionElement({ srcImageUrl, productName, measurementName, clothingType, fitType,
  purchaseDateTime, isSelected, handleClick, purchaseCount, userMeasurementsForItem, handleConfirmation }: PreviousSizeSuggestionElementProps) {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  return (
    <Grid container
      direction="row"
      justifyContent="space-between"
      alignItems="center" style={{
        backgroundColor: isSelected ? '#f2f2f2' : '#f8f8f8',
        borderRadius: '30px',
        padding: '14px',
        border: isSelected ? '1px solid #7a7a7a' : '1px solid #d7d7d7',
        marginBottom: '8px',
        position: 'relative',
      }}
      >
      <Grid xs={3}>
        <img src={srcImageUrl} alt={'disp-img'}
        style={{
          width: '90%'
        }}/>
      </Grid>
      <Grid xs={9} style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '26vw',
      }}>
        <Typography
        style={{
          fontSize: '3.4vw',
          fontWeight: 500,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        }}
        >{productName}</Typography>
        <Box>
          <Typography
          style={{
            fontSize: '2vw',
            letterSpacing: '0.07vw',
            fontWeight: 600,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            paddingBottom: '0.2vw',
            color: '#121212',
          }}
          >SIZE YANG DIPAKAI</Typography>
          <Typography
          style={{
            fontSize: '4.1vw',
            fontWeight: 300,
            color: '#222222'
          }}
          >{measurementName}</Typography>
        </Box>
        <Typography
        style={{
          fontSize: '2.4vw',
          fontWeight: 300,
          color: '#232323',
        }}
        >Dari Pembelian <span style={{textDecoration: 'underline', textUnderlineOffset: '2px'}}>{counterText?.[purchaseCount] ?? 'Terakhir'}</span> Kamu
        </Typography>
      </Grid>
      {
      userMeasurementsForItem ?
      <Box style={{position: 'absolute', bottom: '17px', right: '16px'}}>
        <IconButton
          style={{
            border: '0.5px solid #232323',
            marginRight: '5px',
            borderRadius: '30px',
            backgroundColor: '#f2f2f2',
            color: '#232323',
            padding: '1.2vw 2.4vw',
            [theme.breakpoints.up('sm')]: {
              padding: '5px 10px 5px 10px',
            },
            // display: userMeasurementsForItem?.sizeType === 'regular' ? 'none' : undefined,
            display: 'none'
          }}
          disabled={!userMeasurementsForItem}
          onClick={() => {
            dispatch(closeOverlayAndResetEditView());
            dispatch(setValuesEditView({
              overlayType: 'view',
              clothingType: (clothingType as any),
              fitType: (fitType as any),
              isFullScreen: false,
              currentMeasurementObject: userMeasurementsForItem,
              productDetail: undefined,
              canEdit: false,
              origin: 'order',
              universalSizeHandler: () => {
                handleConfirmation();
              }
            }))
            dispatch(openOverlayEditView());
          }}aria-label="zoom-out">
            <Typography style={{
              fontWeight: isSelected ? 600 : 500,
              letterSpacing: 0.5,
              paddingTop: '2px',
              fontSize: '2.1vw', // 9px -> 3px is 0.8vw
              [theme.breakpoints.up('sm')]: {
                fontSize: '9px',
                paddingTop: '2px',
              }
            }}>
              DETAIL SIZE ⓘ
            </Typography>
        </IconButton>
        <IconButton
          style={{
            border: '1px solid #232323',
            borderRadius: '30px',
            backgroundColor: '#232323',
            color: '#fefefe',
            padding: '1.2vw 2.4vw',
            [theme.breakpoints.up('sm')]: {
              padding: '5px 10px 5px 10px',
            }
          }}
          onClick={() => {
            handleConfirmation();
          }}aria-label="zoom-out">
            <Typography style={{
              fontWeight: 500,
              letterSpacing: 0.5,
              paddingTop: '2px',
              fontSize: '2.1vw', // 9px -> 3px is 0.8vw
              [theme.breakpoints.up('sm')]: {
                fontSize: '9px',
                paddingTop: '2px',
              }
            }}>
              PILIH
            </Typography>
        </IconButton>
      </Box>
      : null
      }
    </Grid>);
}

interface Props {
  handleBack: () => void
  handleNext: (updatedCurrentFlowData: any) => void
  flowVariant?: string
  flowInputVariables?: any
}

export default function UniversalSizeSizeSelect({ handleBack, handleNext, flowVariant, flowInputVariables}: Props) {
  const classes = useStyles()

  const ordersList = useAppSelector(state => state.ordersList.ordersList);
  const clothMeasSuggestions = useAppSelector(state => getClothBodyMeasSuggestions(flowVariant === 'measKitScanMarketplace' && state.overlayUniversalSize.marketplaceOrder ? [state.overlayUniversalSize.marketplaceOrder] : state.ordersList.ordersList));

  useEffect(() => {
    if (flowInputVariables?.clothMeasSuggestion) {
      handleNext({...flowInputVariables.clothMeasSuggestion});
    } else if (flowInputVariables?.clothMeasSuggestionOrderIdItemNumber) {
      const orderIdItemNumber = flowInputVariables?.clothMeasSuggestionOrderIdItemNumber;
      const orderId = orderIdItemNumber?.split('+')?.[0];
      const itemNumber = Number(orderIdItemNumber?.split('+')?.[1]);
      const targetOrderList = ordersList.filter((orderObj: any) => orderObj.orderId === orderId);
      const targetOrder = targetOrderList?.[0] ?? {};

      if (targetOrder?.cartProductList?.length) {
        let cartProductListIndex = -1;
        let counter = 0;
        for (let i = 0; i < targetOrder.cartProductList.length; i++) {
          const cartProductItem = targetOrder.cartProductList[i];
          for (let j = 0; j < cartProductItem.amount; j++) {
            if (counter === itemNumber) {
              cartProductListIndex = i;
            }
            counter++;
          }
        }
  
        const orderObjClothMeasSuggestions = getClothBodyMeasSuggestions(targetOrderList);
  
        handleNext({...(orderObjClothMeasSuggestions?.[cartProductListIndex])});
      }
    } else if (flowInputVariables?.clothingType && flowInputVariables?.fitType && flowInputVariables?.clothMeasValue) {
      handleNext({
        clothingType: flowInputVariables.clothingType,
        fitType: flowInputVariables.fitType,
        clothMeasValue: flowInputVariables.clothMeasValue,
      })
    }
  }, [flowInputVariables, ordersList]);

  // WHEN IT IS AUTO SKIPPED / ALREADY INPUT
  if (flowInputVariables?.clothMeasSuggestion || flowInputVariables?.clothMeasSuggestionOrderIdItemNumber) {
    return (
      <Box style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <CircularProgress/>
      </Box>
    );
  }

  if (flowVariant === 'conversionProductDetail') {
    return (
      <Box style={{
        marginTop: '9px',
        marginBottom: '16px',
        borderRadius: 19,
        border: "solid 1px rgb(167, 167, 167)",
        padding: "12px 14px",
        backgroundColor: "#ffffff",
        maxHeight: "40vh",
        width: "87%",
        display: "flex",
        flexDirection: "column",
      }}>
      <Box style={{
        height: "90%",
        overflowY: "scroll",
        marginTop: '3px',
      }}>
      {
        clothMeasSuggestions.map((suggestionObject, index) => {

          return (
            <PreviousSizeSuggestionElement
              srcImageUrl={suggestionObject.productDisplayImage}
              productName={suggestionObject.productName}
              measurementName={suggestionObject.measurementName}
              purchaseDateTime={suggestionObject.purchaseDateString}
              isSelected={false}
              purchaseCount={suggestionObject.purchaseCount}
              clothingType={suggestionObject.clothingType}
              fitType={suggestionObject.fitType}
              userMeasurementsForItem={suggestionObject.userMeasurementsForItem}
              handleClick={() => {
              }}
              handleConfirmation={() => {
                handleNext({
                  ...clothMeasSuggestions[index],
                })
              }}
            />
          )
        })
      }
      </Box>
      </Box>
    )
  };

  return (
  <>
    <Box
      className={classes.backButton}
      onClick={handleBack}
    >
      <IconButton className={classes.backButtonIcon}>
        <CloseOutlined />
      </IconButton>
    </Box>
    <Box className={classes.dialogContent}>
      {
        flowVariant === "productDetailInstant" ? 
        <>
          <Typography className={classes.pageTitleTop} style={{marginTop: '19px'}}>
            UKURAN KEMARIN, BUAT PRODUK INI
          </Typography>
          <Typography className={classes.pageTitle} style={{marginTop: '5px'}}>
            Pakai <u style={{textUnderlineOffset: '2px'}}>Ukuran Order Kemarin.</u>
          </Typography>
          <Typography className={classes.pageItemDescription} style={{margin: '5px 0px 23px', color: '#535353', fontWeight: 300, letterSpacing: '0.1vw'}}>
            Pilih produk yang kamu sudah suka fitnya, dan <u style={{textUnderlineOffset: '2px'}}>sesuaikan</u> untuk produk ini!
          </Typography>
        </>
        :
        <>
          <Typography className={classes.pageTitle} style={{marginTop: '30px'}}>
            Pilih Ukuran Paling Cocok
          </Typography>
          <Typography className={classes.pageItemDescription} style={{margin: '5px 0px 23px', color: '#535353', fontWeight: 300, letterSpacing: '0.1vw'}}>
            Pilih produk yang kamu yang paling kamu suka fitnya di badan kamu.
          </Typography>
        </>
      }
      {
        clothMeasSuggestions.map((suggestionObject, index) => {

          return (
            <PreviousSizeSuggestionElement
              srcImageUrl={suggestionObject.productDisplayImage}
              productName={suggestionObject.productName}
              measurementName={suggestionObject.measurementName}
              purchaseDateTime={suggestionObject.purchaseDateString}
              isSelected={false}
              purchaseCount={suggestionObject.purchaseCount}
              clothingType={suggestionObject.clothingType}
              fitType={suggestionObject.fitType}
              userMeasurementsForItem={suggestionObject.userMeasurementsForItem}
              handleClick={() => {
              }}
              handleConfirmation={() => {
                handleNext({
                  ...clothMeasSuggestions[index],
                  // clothMeasValue: {...clothMeasSuggestions[selectedIndex].clothMeasValue, panjangBaju: 120}
                })
              }}
            />
          )
        })
      }
      {/* <Box style={{width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '10px'}}>
        <Box style={{width: '30%'}}>
          <OverlayComponentButton
            handleClick={() => handleNext({
              ...clothMeasSuggestions[selectedIndex],
              // clothMeasValue: {...clothMeasSuggestions[selectedIndex].clothMeasValue, panjangBaju: 120}
            })} 
            disabled={selectedIndex === -1}
            isTypeSubmit={false}
            formButtonText="PAKAI"
            buttonMarginTopBottom="0px"
            buttonMarginLeftRight="0px"
          />
        </Box>
      </Box> */}
    </Box>
  </>);
}